/** @format */

import React, { PureComponent } from "react";
import axios from "axios";

// import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns";
import { withRouter } from "react-router-dom";
import { Container, Form, Button } from "react-bootstrap";
import home from "../assets/img/banners/Home-Banner.jpg";
import "../css/requestForm.css";
import proximanova_light from "../assets/fonts/Proxima_Nova_Alt_Light.otf";
import { GLOBAL_DOMAIN } from "../actions/types";

class HomeRequest extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      typeModalSelectedValueConfirmed: "",
      dateModalSelectedValueConfirmed: "", //new Date(),
      timeModalSelectedValueConfirmed: "", //new Date(),
      detailsValue: "",
    };
  }
  getDateArray = () => {
    let dateArray = [];
    let i = 0;

    while (i <= 93) {
      let nextDay = new Date(Date.now() + i * 24 * 60 * 60 * 1000);
      dateArray.push(nextDay);
      i++;
    }

    return dateArray;
  };

  onTypeModalConfirmValue = (value) => {
    this.setState({
      typeModalSelectedValueConfirmed: value,
    });
  };

  onDateModalConfirmValue = (value) => {
    this.setState({
      dateModalShow: !this.state.dateModalShow,
      dateModalSelectedValueConfirmed: value,
    });
  };

  onTimeModalConfirmValue = (value) => {
    this.setState({
      timeModalShow: !this.state.timeModalShow,
      timeModalSelectedValueConfirmed: value,
    });
  };

  onDetailsTextChange = (text) => {
    this.setState({ detailsValue: text.toUpperCase() });
  };

  submitRequest = async () => {
    try {
      let subCat = "Other";

      if (this.state.typeModalSelectedValueConfirmed === "HOUSEKEEPING") {
        subCat = "Housekeeping";
      } else if (this.state.typeModalSelectedValueConfirmed === "HANDYMAN") {
        subCat = "Handyman";
      } else if (
        this.state.typeModalSelectedValueConfirmed === "INTERIOR DESIGN"
      ) {
        subCat = "Interior Design";
      } else if (this.state.typeModalSelectedValueConfirmed === "IT / AV") {
        subCat = "IT / AV";
      } else if (this.state.typeModalSelectedValueConfirmed === "MOVERS") {
        subCat = "Moving";
      } else if (
        this.state.typeModalSelectedValueConfirmed === "ORGANIZATION"
      ) {
        subCat = "Home Organization";
      } else if (this.state.typeModalSelectedValueConfirmed === "STORAGE") {
        subCat = "Storage";
      }

      let preferredDate = this.state.dateModalSelectedValueConfirmed;
      let preferredDateDay = preferredDate.getDate();
      let preferredDateMonth = preferredDate.getMonth() + 1;
      let preferredDateYear = preferredDate.getFullYear();
      let preferredDateString =
        preferredDateYear + "-" + preferredDateMonth + "-" + preferredDateDay;

      const preferredTime = this.state.timeModalSelectedValueConfirmed;
      let preferredHours = preferredTime.getHours();
      let preferredMinutes = preferredTime.getMinutes();
      let AMorPM = "AM";
      if (preferredHours === 0) {
        preferredHours = 12;
      } else if (preferredHours === 12) {
        AMorPM = "PM";
      }
      if (preferredHours > 12) {
        preferredHours -= 12;
        AMorPM = "PM";
      }
      if (preferredMinutes < 10) {
        preferredMinutes = "0" + preferredMinutes;
      }

      let preferredTimeString =
        preferredHours + ":" + preferredMinutes + AMorPM;

      const cat = "Home";
      const subject = "Home Service Request";

      let detailsValueString = this.state.detailsValue;

      if (detailsValueString === "") {
        detailsValueString = "N/A";
      }

      console.log({
        RecordTypeId: "0124A000001NSKo",
        Category__c: cat,
        Sub_Category__c: subCat,
        Preferred_Date__c: preferredDateString,
        Preferred_Time__c: preferredTimeString, //this.state.timeModalSelectedValueConfirmedString,
        Additional_Details__c: detailsValueString,
        Subject: subject,
        Origin: "Web Portal",
        ContactId: localStorage.getItem("contactId"),
      });

      let jsonObj = JSON.stringify({
        RecordTypeId: "0124A000001NSKo",
        Category__c: cat,
        Sub_Category__c: subCat,
        Preferred_Date__c: preferredDateString,
        Preferred_Time__c: preferredTimeString, //this.state.timeModalSelectedValueConfirmedString,
        Additional_Details__c: detailsValueString,
        Subject: subject,
        Origin: "Web Portal",
        ContactId: localStorage.getItem("contactId"),
      });

      let response = await axios.get(`${GLOBAL_DOMAIN}/api/request/`, {
        params: {
          json: jsonObj,
          token: localStorage.getItem("token"),
        },
      });
      return { success: true, access_token: response.data.access_token };
    } catch (err) {
      console.log("Submit Home Request err", err);

      return { success: false, error: err };
    }
  };

  reAuthenticate = async () => {
    // If access token comes back expired
    try {
      // let response = await axios.post(
      //   "https://login.salesforce.com/services/oauth2/token", // url
      //   //`username=mfazio%40livunltd.com.playground&password=LIVunLtd2018%25%25%25&grant_type=password&client_id=3MVG9ahGHqp.k2_yLsU4D7ySvCWdfD55aKSeka526MzGoLsHlD.L30lxMjcq821nxci.h4fDBHBTLEG0IhkUW&client_secret=5867736434310092893`, // body
      //   `username=dcohen%40aamenities.com&password=LIV4APPS2018&grant_type=password&client_id=3MVG9yZ.WNe6byQC3n2dOmqB12z8defijpQTO5.eitnjVmfGyBlBh4zLg6CcydYQzCl64htoZXf9pf0aAqNLr&client_secret=6715413000142592242`,
      //   {
      //     //config
      //     headers: {
      //       "Content-Type": "application/x-www-form-urlencoded"
      //     }
      //   }
      // );
      let response = await axios.get(`${GLOBAL_DOMAIN}/api/auth/token`);
      return { success: true, access_token: response.data.access_token };
    } catch (err) {
      console.log("getSalesforceToken err on login", err);
      return { success: false, error: err };
    }
  };

  attemptSubmitRequest = async () => {
    // Validation Step

    if (
      !this.state.typeModalSelectedValueConfirmed ||
      !this.state.dateModalSelectedValueConfirmed ||
      !this.state.timeModalSelectedValueConfirmed
    ) {
      return;
      //   return Alert.alert(
      //     "Could Not Submit Request",
      //     "Please fill out all the required fields marked with a * before submitting request",
      //     [
      //       {
      //         text: "OK",
      //         onPress: () => console.log("OK Pressed on validation step")
      //       }
      //     ]
      //   );
    }

    let response = await this.submitRequest();

    // if response says 'Session expired or invalid' then attempt to reauthenticate
    // If that fails, user must log in again, if works, then attempt to submit request again

    if (response.success) {
      //Request successful, navigate to Request Confirmation screen

      this.setState({
        typeModalSelectedValueConfirmed: "",
        dateModalSelectedValueConfirmed: new Date(),
        timeModalSelectedValueConfirmed: new Date(),
        detailsValue: "",
      });
      this.props.history.push("/requests/submitted");

      //   this.props.navigation.navigate("MakeRequestConfirmation", {
      //     barStyle: "light-content"
      //   });
    } else {
      // Submit request failed: Try to get new Salesforce token

      let reauthResponse = await this.reAuthenticate();

      if (reauthResponse.success) {
        //New Token, add to redux and retry submitting request

        localStorage.setItem("token", reauthResponse.access_token);

        let responseTwo = await this.submitRequest();

        if (responseTwo.success) {
          // Second try request worked

          this.setState({
            typeModalSelectedValueConfirmed: "",
            dateModalSelectedValueConfirmed: new Date(),
            timeModalSelectedValueConfirmed: new Date(),
            detailsValue: "",
          });
          this.props.history.push("/requests/submitted");
        } else {
          // Second try failed, send alert notification
          return;
        }
      }
    }
  };
  render() {
    return (
      <div style={{ marginTop: "100px", marginBottom: "50px" }}>
        <div className="request_title_div">
          <p className="request_title">HOME</p>
        </div>
        <img
          src={home}
          style={{
            height: "270px",
            objectFit: "cover",
            width: "100%",
          }}
          alt="home-banner"
        ></img>
        <Container>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              this.attemptSubmitRequest();
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* <p style={{ textAlign: "center", fontSize: 40, fontWeight: 600 }}>
              Home
            </p> */}
            <br />
            <Form.Group className="form_item">
              {/* <Form.Label>Category</Form.Label> */}
              <Form.Control
                as="select"
                placeholder="Category"
                value={this.state.typeModalSelectedValueConfirmed}
                onChange={(e) =>
                  this.onTypeModalConfirmValue.call(this, e.target.value)
                }
                required
                style={{
                  height: "60px",
                  border: "2px #EFEFEF solid",
                  fontFamily: proximanova_light,
                }}
              >
                <option value="">CATEGORY*</option>
                <option>Handyman</option>
                <option>Housekeeping</option>
                <option>Interior Design</option>
                <option>IT/AV</option>
                <option>Movers</option>
                <option>Organization</option>
                <option>Storage</option>
                <option>Other</option>
              </Form.Control>
            </Form.Group>
            <Form.Group className="form_item">
              {/* <Form.Label>Preferred Date</Form.Label>
                <br /> */}
              <DatePicker
                selected={this.state.dateModalSelectedValueConfirmed}
                onChange={(e) => this.onDateModalConfirmValue(e)}
                minDate={new Date()}
                maxDate={addDays(new Date(), 90)}
                placeholderText="PREFERRED DATE"
              />
            </Form.Group>
            <Form.Group className="form_item">
              {/* <Form.Label>Preferred Time</Form.Label>
                <br /> */}
              <DatePicker
                selected={
                  this.state.timeModalSelectedValueConfirmed
                    ? this.state.timeModalSelectedValueConfirmed.getTime()
                    : ""
                }
                showTimeSelect
                showTimeSelectOnly
                // minTime={new Date()}
                // maxTime={setHours(setMinutes(new Date(), 30), 23)}
                dateFormat="h:mm aa"
                onChange={(e) => this.onTimeModalConfirmValue(e)}
                placeholderText="PREFERRED TIME"
              ></DatePicker>
            </Form.Group>
            <Form.Group className="form_item">
              <Form.Control
                onChange={(e) => this.onDetailsTextChange(e.target.value)}
                placeholder="ADDITIONAL DETAILS"
                style={{
                  height: "60px",
                  border: "2px #EFEFEF solid",
                  fontFamily: proximanova_light,
                  textAlign: "center",
                }}
              />
            </Form.Group>

            <Button
              variant="dark"
              className="form_submit_button"
              type="submit"
              style={{ backgroundColor: "black" }}
            >
              <p style={{ fontSize: "24px", margin: "0px" }}>SUBMIT</p>
            </Button>
          </Form>
        </Container>
      </div>
    );
  }
}

export default withRouter(HomeRequest);
